import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import require$$0 from "react";
var jsxRuntime = {
  exports: {}
};
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production_min;

function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = require$$0,
      k = Symbol.for("react.element"),
      l = Symbol.for("react.fragment"),
      m = Object.prototype.hasOwnProperty,
      n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
      p = {
    key: true,
    ref: true,
    __self: true,
    __source: true
  };

  function q(c, a, g) {
    var b,
        d = {},
        e = null,
        h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);

    for (b in a) {
      m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    }

    if (c && c.defaultProps) for (b in a = c.defaultProps, a) {
      void 0 === d[b] && (d[b] = a[b]);
    }
    return {
      $$typeof: k,
      type: c,
      key: e,
      ref: h,
      props: d,
      _owner: n.current
    };
  }

  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}

var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development;

function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;

  if (process.env.NODE_ENV !== "production") {
    (function () {
      var React = require$$0;
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";

      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }

        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }

        return null;
      }

      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            printWarning("error", format, args);
          }
        }
      }

      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();

          if (stack !== "") {
            format += "%s";
            args = args.concat([stack]);
          }

          var argsWithFormat = args.map(function (item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }

      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }

      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }

        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }

        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }

        return false;
      }

      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;

        if (displayName) {
          return displayName;
        }

        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }

      function getContextName(type) {
        return type.displayName || "Context";
      }

      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }

        {
          if (typeof type.tag === "number") {
            error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }

        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }

        if (typeof type === "string") {
          return type;
        }

        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";

          case REACT_PORTAL_TYPE:
            return "Portal";

          case REACT_PROFILER_TYPE:
            return "Profiler";

          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";

          case REACT_SUSPENSE_TYPE:
            return "Suspense";

          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }

        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";

            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";

            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, "ForwardRef");

            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;

              if (outerName !== null) {
                return outerName;
              }

              return getComponentNameFromType(type.type) || "Memo";

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  return getComponentNameFromType(init(payload));
                } catch (x) {
                  return null;
                }
              }
          }
        }

        return null;
      }

      var assign = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;

      function disabledLog() {}

      disabledLog.__reactDisabledLog = true;

      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }

          disabledDepth++;
        }
      }

      function reenableLogs() {
        {
          disabledDepth--;

          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
          }

          if (disabledDepth < 0) {
            error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }

      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;

      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === void 0) {
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || "";
            }
          }

          return "\n" + prefix + name;
        }
      }

      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }

      function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) {
          return "";
        }

        {
          var frame = componentFrameCache.get(fn);

          if (frame !== void 0) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }

        try {
          if (construct) {
            var Fake = function Fake() {
              throw Error();
            };

            Object.defineProperty(Fake.prototype, "props", {
              set: function set() {
                throw Error();
              }
            });

            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }

              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }

              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }

            fn();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;

            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              c--;
            }

            for (; s >= 1 && c >= 0; s--, c--) {
              if (sampleLines[s] !== controlLines[c]) {
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--;

                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");

                      if (fn.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn.displayName);
                      }

                      {
                        if (typeof fn === "function") {
                          componentFrameCache.set(fn, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }

                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }

        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        {
          if (typeof fn === "function") {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }

      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }

      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }

      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }

        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }

        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }

        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");

          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }

        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);

            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
              }
          }
        }

        return "";
      }

      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }

      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          var has = Function.call.bind(hasOwnProperty);

          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0;

              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }

                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$1 = ex;
              }

              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }

              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }

      var isArrayImpl = Array.isArray;

      function isArray(a) {
        return isArrayImpl(a);
      }

      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }

      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }

      function testStringCoercion(value) {
        return "" + value;
      }

      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }

      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      var didWarnAboutStringRefs;
      {
        didWarnAboutStringRefs = {};
      }

      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;

            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== void 0;
      }

      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;

            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== void 0;
      }

      function warnIfStringRefCannotBeAutoConverted(config, self) {
        {
          if (typeof config.ref === "string" && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);

            if (!didWarnAboutStringRefs[componentName]) {
              error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
              didWarnAboutStringRefs[componentName] = true;
            }
          }
        }
      }

      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function warnAboutAccessingKey() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };

          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }

      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function warnAboutAccessingRef() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };

          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }

      var ReactElement = function ReactElement(type, key, ref, self, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type: type,
          key: key,
          ref: ref,
          props: props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          element._store = {};
          Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          });
          Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
          });
          Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });

          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };

      function jsxDEV(type, config, maybeKey, source, self) {
        {
          var propName;
          var props = {};
          var key = null;
          var ref = null;

          if (maybeKey !== void 0) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = "" + maybeKey;
          }

          if (hasValidKey(config)) {
            {
              checkKeyStringCoercion(config.key);
            }
            key = "" + config.key;
          }

          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
          }

          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          }

          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;

            for (propName in defaultProps) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps[propName];
              }
            }
          }

          if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;

            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }

            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }

          return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
        }
      }

      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }

      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }

      function isValidElement(object) {
        {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }

      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);

            if (name) {
              return "\n\nCheck the render method of `" + name + "`.";
            }
          }

          return "";
        }
      }

      function getSourceInfoErrorAddendum(source) {
        {
          if (source !== void 0) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
          }

          return "";
        }
      }

      var ownerHasKeyUseWarning = {};

      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();

          if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;

            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }

          return info;
        }
      }

      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }

          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }

          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";

          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }

          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }

      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== "object") {
            return;
          }

          if (isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];

              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);

            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;

                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }

      function validatePropTypes(element) {
        {
          var type = element.type;

          if (type === null || type === void 0 || typeof type === "string") {
            return;
          }

          var propTypes;

          if (typeof type === "function") {
            propTypes = type.propTypes;
          } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes = type.propTypes;
          } else {
            return;
          }

          if (propTypes) {
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
          } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;

            var _name = getComponentNameFromType(type);

            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
          }

          if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
            error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
      }

      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);

          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];

            if (key !== "children" && key !== "key") {
              setCurrentlyValidatingElement$1(fragment);
              error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }

          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
          }
        }
      }

      function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        {
          var validType = isValidElementType(type);

          if (!validType) {
            var info = "";

            if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
              info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }

            var sourceInfo = getSourceInfoErrorAddendum(source);

            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }

            var typeString;

            if (type === null) {
              typeString = "null";
            } else if (isArray(type)) {
              typeString = "array";
            } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
              info = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type;
            }

            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
          }

          var element = jsxDEV(type, props, key, source, self);

          if (element == null) {
            return element;
          }

          if (validType) {
            var children = props.children;

            if (children !== void 0) {
              if (isStaticChildren) {
                if (isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }

                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }

          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }

          return element;
        }
      }

      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }

      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }

      var jsx = jsxWithValidationDynamic;
      var jsxs = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx;
      reactJsxRuntime_development.jsxs = jsxs;
    })();
  }

  return reactJsxRuntime_development;
}

if (process.env.NODE_ENV === "production") {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development();
}

var jsxRuntimeExports = jsxRuntime.exports;

var Advanced = function Advanced(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.324 3h13.352c.258 0 .494 0 .692.016.213.018.446.057.677.175.329.168.596.435.764.765.118.23.157.463.175.676.016.198.016.434.016.692v13.352c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764c-.23.118-.463.157-.676.175-.198.016-.434.016-.692.016H5.324c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676A9.053 9.053 0 0 1 3 18.676V5.324c0-.258 0-.494.016-.692.018-.213.057-.446.175-.676a1.75 1.75 0 0 1 .765-.765c.23-.118.463-.157.676-.175C4.83 3 5.066 3 5.324 3ZM4.63 4.53h.001Zm.002-.001a.626.626 0 0 1 .121-.018c.13-.01.304-.011.596-.011h13.3c.292 0 .467 0 .596.011a.625.625 0 0 1 .12.018.25.25 0 0 1 .105.104.638.638 0 0 1 .018.121c.01.13.011.304.011.596v13.3c0 .292 0 .467-.011.596a.638.638 0 0 1-.018.12.25.25 0 0 1-.105.105.636.636 0 0 1-.12.018c-.13.01-.304.011-.596.011H5.35c-.292 0-.467 0-.596-.011a.638.638 0 0 1-.12-.018.25.25 0 0 1-.105-.105.625.625 0 0 1-.018-.12 8.336 8.336 0 0 1-.011-.596V5.35c0-.292 0-.467.011-.596a.626.626 0 0 1 .018-.12.25.25 0 0 1 .104-.105Zm-.103.102v.001Zm0 14.738v-.001Zm.1.101h.002Zm14.74 0h-.002Zm.1-.1v-.002Zm0-14.74v.002Zm-.102-.1h.001ZM15.18 8.79c-1.715-1.72-4.65-1.72-6.362 0a4.528 4.528 0 0 0 0 6.389 4.49 4.49 0 0 0 5.787.487l-.135-.134-.002-.002-1.95-1.95a.75.75 0 0 1 1.061-1.06l1.948 1.948.002.002.136.135a4.53 4.53 0 0 0-.485-5.815ZM7.757 7.73c2.298-2.307 6.185-2.307 8.486 0a6.028 6.028 0 0 1 0 8.508 5.99 5.99 0 0 1-8.486 0 6.028 6.028 0 0 1 0-8.507Z"
    })
  }));
};

var App = function App(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M6.5 9a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM10 9a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm3.5 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.5 9.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm3.5 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm3.5 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-7-.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM10 9a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm3-.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 5.75C2 4.784 2.784 4 3.75 4h16.5c.966 0 1.75.784 1.75 1.75v6.5a.75.75 0 0 1-1.5 0v-6.5a.25.25 0 0 0-.25-.25H3.75a.25.25 0 0 0-.25.25v13.5c0 .138.112.25.25.25h8.5a.75.75 0 0 1 0 1.5h-8.5A1.75 1.75 0 0 1 2 19.25V5.75Zm11.47 7.72a.75.75 0 0 1 .75-.187l7 2.154a.75.75 0 0 1 .115 1.388l-3.007 1.503-1.503 3.007a.75.75 0 0 1-1.388-.114l-2.154-7a.75.75 0 0 1 .187-.751Zm1.663 1.663 1.187 3.857.778-1.556a.75.75 0 0 1 .336-.336l1.556-.778-3.856-1.187Z"
    })]
  }));
};

var Apps = function Apps(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M10.25 3.75H11a.75.75 0 0 0-.75-.75v.75Zm0 6.5V11a.75.75 0 0 0 .75-.75h-.75Zm-6.5 0H3c0 .414.336.75.75.75v-.75Zm.546-6.391.34.668-.34-.668Zm-.437.437.668.34-.668-.34Zm9.891-.546V3a.75.75 0 0 0-.75.75h.75Zm6.5 6.5V11a.75.75 0 0 0 .75-.75h-.75Zm-6.5 0H13c0 .414.336.75.75.75v-.75Zm5.954-6.391-.34.668.34-.668Zm.437.437-.668.34.668-.34ZM3.75 13.75V13a.75.75 0 0 0-.75.75h.75Zm6.5 0H11a.75.75 0 0 0-.75-.75v.75Zm0 6.5V21a.75.75 0 0 0 .75-.75h-.75Zm-5.954-.109.34-.668-.34.668Zm-.437-.437.668-.34-.668.34Zm16.74 1.955a.75.75 0 0 0 1.06-1.06l-1.06 1.06Zm-1.297-2.357-.531-.53.531.53ZM5.35 4.5h4.9V3h-4.9v1.5Zm4.15-.75v6.5H11v-6.5H9.5Zm.75 5.75h-6.5V11h6.5V9.5Zm-5.75.75v-4.9H3v4.9h1.5ZM5.35 3c-.268 0-.513 0-.718.016a1.774 1.774 0 0 0-.676.175l.68 1.336c-.016.009-.002-.006.118-.016.13-.01.304-.011.596-.011V3ZM4.5 5.35c0-.292 0-.467.011-.596.01-.12.025-.134.016-.117l-1.336-.681a1.77 1.77 0 0 0-.175.676C3 4.837 3 5.082 3 5.35h1.5Zm-.544-2.16a1.75 1.75 0 0 0-.765.766l1.336.68a.25.25 0 0 1 .11-.109l-.681-1.336ZM13.75 4.5h4.9V3h-4.9v1.5Zm5.75.85v4.9H21v-4.9h-1.5Zm.75 4.15h-6.5V11h6.5V9.5Zm-5.75.75v-6.5H13v6.5h1.5Zm4.15-5.75c.292 0 .467 0 .596.011.12.01.134.025.117.016l.681-1.336a1.774 1.774 0 0 0-.676-.175C19.164 3 18.918 3 18.65 3v1.5Zm2.35.85c0-.268 0-.513-.016-.718a1.775 1.775 0 0 0-.175-.676l-1.336.68c-.009-.016.006-.002.016.118.01.13.011.304.011.596H21Zm-1.637-.823a.25.25 0 0 1 .11.11l1.336-.681a1.75 1.75 0 0 0-.765-.765l-.68 1.336ZM3.75 14.5h6.5V13h-6.5v1.5Zm5.75-.75v6.5H11v-6.5H9.5Zm.75 5.75h-4.9V21h4.9v-1.5Zm-5.75-.85v-4.9H3v4.9h1.5Zm.85.85c-.292 0-.467 0-.596-.011-.12-.01-.134-.025-.117-.016l-.681 1.336c.23.118.463.157.676.175.205.017.45.016.718.016v-1.5ZM3 18.65c0 .268 0 .514.016.718.018.213.057.446.175.677l1.336-.682c.009.017-.006.003-.016-.117a8.337 8.337 0 0 1-.011-.596H3Zm1.636.823a.25.25 0 0 1-.109-.11l-1.336.681c.168.33.435.598.765.765l.68-1.336ZM17 19.508a2.5 2.5 0 0 1-2.5-2.5H13a4 4 0 0 0 4 4v-1.5Zm-2.5-2.5a2.5 2.5 0 0 1 2.5-2.5v-1.5a4 4 0 0 0-4 4h1.5Zm2.5-2.5a2.5 2.5 0 0 1 2.5 2.5H21a4 4 0 0 0-4-4v1.5Zm1.772 5.324 1.826 1.827 1.061-1.06-1.827-1.827-1.06 1.06Zm.728-2.824a2.49 2.49 0 0 1-.73 1.765l1.063 1.058A3.99 3.99 0 0 0 21 17.008h-1.5Zm-.73 1.765a2.49 2.49 0 0 1-1.77.735v1.5a3.99 3.99 0 0 0 2.833-1.177l-1.062-1.058Z"
    })
  }));
};

var ArrowLeft = function ArrowLeft(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12Zm7.56-.75 1.97-1.97a.75.75 0 0 0-1.06-1.06l-2.897 2.896a1.25 1.25 0 0 0 0 1.768l2.897 2.896a.75.75 0 1 0 1.06-1.06l-1.97-1.97h6.69a.75.75 0 0 0 0-1.5H9.56Z"
    })
  }));
};

var ArrowRight = function ArrowRight(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10Zm-7.56.75-1.97 1.97a.75.75 0 1 0 1.06 1.06l2.897-2.896a1.25 1.25 0 0 0 0-1.768L13.53 8.22a.75.75 0 1 0-1.06 1.06l1.97 1.97H7.75a.75.75 0 0 0 0 1.5h6.69Z"
    })
  }));
};

var ArrowUpRight = function ArrowUpRight(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      d: "M7.995 5.75a.75.75 0 0 1 .75-.75h8.505c.966 0 1.75.784 1.75 1.75v9.496a.75.75 0 0 1-1.5 0V7.56L7.03 18.03a.75.75 0 0 1-1.06-1.061L16.44 6.5H8.744a.75.75 0 0 1-.75-.75Z",
      clipRule: "evenodd"
    })
  }));
};

var Badge = function Badge(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.035 2.44a1.278 1.278 0 0 1 1.93 0l1.842 2.12 2.774-.44a1.278 1.278 0 0 1 1.477 1.24l.049 2.808 2.407 1.446c.666.4.824 1.296.335 1.9l-1.768 2.182.916 2.655a1.278 1.278 0 0 1-.965 1.671l-2.757.535-1.006 2.623a1.278 1.278 0 0 1-1.813.66L12 20.476 9.544 21.84a1.278 1.278 0 0 1-1.813-.66l-1.006-2.622-2.757-.535a1.278 1.278 0 0 1-.965-1.67l.915-2.656-1.767-2.182c-.49-.604-.331-1.5.335-1.9l2.407-1.446.049-2.808A1.278 1.278 0 0 1 6.42 4.12l2.773.44 1.842-2.12Zm1.073 17.977Zm-.215 0ZM12 3.618l-1.755 2.02c-.29.332-.73.493-1.165.424l-2.643-.42-.046 2.676a1.28 1.28 0 0 1-.62 1.074l-2.294 1.377 1.685 2.08c.277.342.358.803.215 1.22l-.872 2.53 2.627.51c.433.084.792.386.95.797l.958 2.499 2.34-1.298a1.278 1.278 0 0 1 1.24 0l2.34 1.298.958-2.499c.158-.412.517-.713.95-.797l2.627-.51-.872-2.53a1.278 1.278 0 0 1 .215-1.22l1.685-2.08-2.294-1.377a1.278 1.278 0 0 1-.62-1.074l-.046-2.676-2.643.42a1.278 1.278 0 0 1-1.165-.424L12 3.617Zm3.184 16.91ZM15.03 10.22a.75.75 0 0 1 0 1.06l-3.5 3.5a.75.75 0 0 1-1.06 0l-1.5-1.5a.75.75 0 1 1 1.06-1.06l.97.97 2.97-2.97a.75.75 0 0 1 1.06 0Z"
    })
  }));
};

var Bell = function Bell(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      d: "M5.658 2.232a.75.75 0 0 1-.027 1.06 9.247 9.247 0 0 0-2.527 4.164.75.75 0 0 1-1.442-.411 10.747 10.747 0 0 1 2.936-4.84.75.75 0 0 1 1.06.027Zm12.684 0a.75.75 0 0 1 1.06-.028 10.746 10.746 0 0 1 2.936 4.84.75.75 0 1 1-1.442.412 9.246 9.246 0 0 0-2.527-4.164.75.75 0 0 1-.027-1.06ZM4.304 8.554a7.795 7.795 0 0 1 15.392 0l1.357 8.417A1.75 1.75 0 0 1 19.326 19h-2.834c-.849 1.75-2.512 3-4.492 3s-3.643-1.25-4.492-3H4.674a1.75 1.75 0 0 1-1.727-2.029l1.357-8.417ZM9.246 19c.678.937 1.68 1.5 2.754 1.5s2.076-.563 2.754-1.5H9.245ZM12 3.5a6.295 6.295 0 0 0-6.215 5.293L4.427 17.21a.25.25 0 0 0 .247.29h14.652a.25.25 0 0 0 .247-.29l-1.358-8.417A6.295 6.295 0 0 0 12 3.5Z",
      clipRule: "evenodd"
    })
  }));
};

var Bolt = function Bolt(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      d: "M12.5 3.159 4.678 14.5h5.572c.69 0 1.25.56 1.25 1.25v5.091L19.322 9.5H13.75c-.69 0-1.25-.56-1.25-1.25V3.159Zm-.779-1.513C12.417.636 14 1.129 14 2.356V8h5.798a1.25 1.25 0 0 1 1.029 1.96l-8.548 12.394c-.696 1.01-2.279.517-2.279-.71V16H4.202a1.25 1.25 0 0 1-1.029-1.96l8.548-12.394Z",
      clipRule: "evenodd"
    })
  }));
};

var Book = function Book(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 4.75A2.75 2.75 0 0 1 6.75 2h10.5A2.75 2.75 0 0 1 20 4.75v14.5A2.75 2.75 0 0 1 17.25 22H6.75A2.75 2.75 0 0 1 4 19.25V4.75ZM7 20.5a1.5 1.5 0 0 1 0-3h10.25c.45 0 .875-.108 1.25-.3v2.05c0 .69-.56 1.25-1.25 1.25H7Zm11.5-5.75c0 .69-.56 1.25-1.25 1.25H7c-.546 0-1.059.146-1.5.401V4.75c0-.69.56-1.25 1.25-1.25h10.5c.69 0 1.25.56 1.25 1.25v10ZM8 7a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 8 7Zm0 4a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5A.75.75 0 0 1 8 11Z"
    })
  }));
};

var Box = function Box(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M21.75 17.34V6.75a.762.762 0 0 0-.052-.263v-.06a.912.912 0 0 0-.143-.21.551.551 0 0 0-.15-.112l-9-5.25a.75.75 0 0 0-.75 0l-9 5.25a.552.552 0 0 0-.15.112.912.912 0 0 0-.143.21v.06a.75.75 0 0 0-.112.263v10.59c-.004.05-.004.1 0 .15.02.044.042.086.067.128.021.042.046.082.075.12l.113.097a.513.513 0 0 0 .075.06l9 5.25h.12c.163.07.347.07.51 0h.12l9-5.25a.51.51 0 0 0 .075-.06l.112-.098a.69.69 0 0 0 .076-.12c.025-.04.047-.083.067-.127.034-.048.064-.098.09-.15Zm-18-9.285 7.5 4.373v8.767l-7.5-4.373V8.055Zm9 4.373 7.5-4.373v8.767l-7.5 4.373v-8.768ZM12 2.37l7.5 4.38-7.5 4.38-7.5-4.38L12 2.37Z"
    })
  }));
};

var Brackets = function Brackets(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 4.75C4 3.784 4.784 3 5.75 3h2.5a.75.75 0 0 1 0 1.5h-2.5a.25.25 0 0 0-.25.25V11c0 .372-.116.716-.314 1 .198.284.314.628.314 1v6.25c0 .138.112.25.25.25h2.5a.75.75 0 0 1 0 1.5h-2.5A1.75 1.75 0 0 1 4 19.25V13a.25.25 0 0 0-.25-.25h-1a.75.75 0 0 1 0-1.5h1A.25.25 0 0 0 4 11V4.75Zm11-1a.75.75 0 0 1 .75-.75h2.5c.966 0 1.75.784 1.75 1.75V11c0 .138.112.25.25.25h1a.75.75 0 0 1 0 1.5h-1A.25.25 0 0 0 20 13v6.25A1.75 1.75 0 0 1 18.25 21h-2.5a.75.75 0 0 1 0-1.5h2.5a.25.25 0 0 0 .25-.25V13c0-.372.116-.716.314-1a1.742 1.742 0 0 1-.314-1V4.75a.25.25 0 0 0-.25-.25h-2.5a.75.75 0 0 1-.75-.75Z"
    })
  }));
};

var Brightness = function Brightness(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("g", {
      clipPath: "url(#icon/brightness__a)",
      children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
        d: "M6.534 12a5.465 5.465 0 1 0 10.93 0 5.465 5.465 0 0 0-10.93 0Zm5.518-4.034a4.085 4.085 0 0 1 3.538 6.13 4.086 4.086 0 0 1-3.538 2.042V7.966Zm.348-2.554V2.96a.46.46 0 1 0-.918 0v2.452a.46.46 0 0 0 .918 0Zm6.274.484a.46.46 0 0 0-.65-.65l-1.727 1.733a.46.46 0 0 0 .65.65l1.727-1.733Zm-.086 6.504h2.451a.46.46 0 1 0 0-.918h-2.451a.46.46 0 0 0 0 .918Zm-2.218 3.897a.458.458 0 0 0 0 .65l1.734 1.735a.462.462 0 0 0 .785-.325.457.457 0 0 0-.136-.325l-1.733-1.735a.46.46 0 0 0-.65 0Zm-4.77 2.291v2.452a.46.46 0 1 0 .918 0v-2.452a.46.46 0 0 0-.918 0Zm-6.282-.484a.461.461 0 0 0 .325.784.455.455 0 0 0 .325-.134l1.734-1.735v.001a.46.46 0 0 0-.65-.65l-1.734 1.734ZM2.5 12.052a.46.46 0 0 0 .46.458h2.45a.46.46 0 0 0 0-.918H2.96a.462.462 0 0 0-.46.46Zm5.13-4.35a.458.458 0 0 0 0-.65L5.894 5.318a.46.46 0 0 0-.65.65L6.98 7.702c.18.178.47.178.65 0Z"
      })
    }), /* @__PURE__ */jsxRuntimeExports.jsx("defs", {
      children: /* @__PURE__ */jsxRuntimeExports.jsx("clipPath", {
        id: "icon/brightness__a",
        children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
          transform: "translate(2 2)",
          d: "M0 0h20v20H0z"
        })
      })
    })]
  }));
};

var Calculator = function Calculator(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      d: "M4 3.75C4 2.784 4.784 2 5.75 2h12.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 18.25 22H5.75A1.75 1.75 0 0 1 4 20.25V3.75Zm1.75-.25a.25.25 0 0 0-.25.25V7h13V3.75a.25.25 0 0 0-.25-.25H5.75Zm12.75 5h-13v11.75c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V8.5Z",
      clipRule: "evenodd"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M10 12.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM10 16.75a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM15 12.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM15 16.75a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      d: "M10.5 12.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5-4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-6-4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm0 4.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm5.5-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z",
      clipRule: "evenodd"
    })]
  }));
};

var Calendar = function Calendar(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 5.75A2.75 2.75 0 0 1 5.75 3h12.5A2.75 2.75 0 0 1 21 5.75v12.5A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25V5.75ZM4.5 8.5v9.75c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V8.5h-15Zm15-1.5h-15V5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25V7Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M7 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm0 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm0-4a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
    })]
  }));
};

var Chat = function Chat(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.252 4.75c0-.966.784-1.75 1.75-1.75h12.25c.967 0 1.75.784 1.75 1.75v8.5a1.75 1.75 0 0 1-1.75 1.75h-2.25v2.25a1.75 1.75 0 0 1-1.75 1.75h-5.555l-4.33 2.406a.75.75 0 0 1-1.115-.656V19h-1.5a1.75 1.75 0 0 1-1.75-1.75v-8.5c0-.966.784-1.75 1.75-1.75h2.5V4.75Zm-2.5 3.75a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h2.25a.75.75 0 0 1 .75.75v1.225l3.386-1.88a.75.75 0 0 1 .364-.095h5.75a.25.25 0 0 0 .25-.25v-2.942a.735.735 0 0 1 0-.116V8.75a.25.25 0 0 0-.25-.25h-12.5Zm14.25 5V8.75A1.75 1.75 0 0 0 16.252 7h-8.5V4.75a.25.25 0 0 1 .25-.25h12.25a.25.25 0 0 1 .25.25v8.5a.25.25 0 0 1-.25.25h-2.25Z"
    })
  }));
};

var Check = function Check(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("g", {
      clipPath: "url(#icon/check__a)",
      children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.225 3.67a.75.75 0 0 1 .105 1.055L8.87 19.955a.75.75 0 0 1-1.11.056l-5.54-5.538a.75.75 0 0 1 1.061-1.061l4.953 4.952L20.169 3.775a.75.75 0 0 1 1.056-.105Z"
      })
    }), /* @__PURE__ */jsxRuntimeExports.jsx("defs", {
      children: /* @__PURE__ */jsxRuntimeExports.jsx("clipPath", {
        id: "icon/check__a",
        children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
          transform: "translate(2 3)",
          d: "M0 0h20v18H0z"
        })
      })
    })]
  }));
};

var CheckCircle = function CheckCircle(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.475-3.08a.75.75 0 0 1 .106 1.055l-4.5 5.5a.75.75 0 0 1-1.111.055l-2-2a.75.75 0 1 1 1.06-1.06l1.414 1.414 3.975-4.859a.75.75 0 0 1 1.056-.105Z"
    })
  }));
};

var ChevronDown = function ChevronDown(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.47 9.47a.75.75 0 0 1 1.06 0L12 12.94l3.47-3.47a.75.75 0 1 1 1.06 1.06l-3.646 3.647a1.25 1.25 0 0 1-1.768 0L7.47 10.53a.75.75 0 0 1 0-1.06Z"
    })
  }));
};

var Clock = function Clock(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-5a.75.75 0 0 1 .75.75v3.94l2.53 2.53a.75.75 0 1 1-1.06 1.06l-2.75-2.75a.75.75 0 0 1-.22-.53V7.75A.75.75 0 0 1 12 7Z"
    })
  }));
};

var Code = function Code(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      d: "M3 4.75C3 3.784 3.784 3 4.75 3h14.5c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 19.25 21H4.75A1.75 1.75 0 0 1 3 19.25V4.75Zm1.75-.25a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25h14.5a.25.25 0 0 0 .25-.25V4.75a.25.25 0 0 0-.25-.25H4.75Zm6.03 3.97a.75.75 0 0 1 0 1.06l-2.293 2.293a.25.25 0 0 0 0 .354l2.293 2.293a.75.75 0 1 1-1.06 1.06l-2.293-2.293a1.75 1.75 0 0 1 0-2.474L9.72 8.47a.75.75 0 0 1 1.06 0Zm2.44 0a.75.75 0 0 1 1.06 0l2.293 2.293a1.75 1.75 0 0 1 0 2.474L14.28 15.53a.75.75 0 1 1-1.06-1.06l2.293-2.293a.25.25 0 0 0 0-.354L13.22 9.53a.75.75 0 0 1 0-1.06Z",
      clipRule: "evenodd"
    })
  }));
};

var Columns = function Columns(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.75 5.5a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h7.5v-13h-7.5Zm9 0v13h7.5a.25.25 0 0 0 .25-.25V5.75a.25.25 0 0 0-.25-.25h-7.5ZM2 5.75C2 4.784 2.784 4 3.75 4h16.5c.966 0 1.75.784 1.75 1.75v12.5A1.75 1.75 0 0 1 20.25 20H3.75A1.75 1.75 0 0 1 2 18.25V5.75Z"
    })
  }));
};

var Cursor = function Cursor(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m4.246 4.246 5.732 15.922 2.777-6.734a1.25 1.25 0 0 1 .68-.679l6.733-2.777L4.246 4.246Zm-1.592.008c-.358-.995.605-1.958 1.6-1.6l17.031 6.132c1.076.387 1.11 1.896.053 2.332l-7.236 2.984-2.984 7.236c-.436 1.057-1.945 1.023-2.332-.053L2.654 4.254Z"
    })
  }));
};

var Dashboard = function Dashboard(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.657 7.343a8 8 0 0 0-11.62 10.99 1 1 0 0 1-1.49 1.334C1.028 15.74 1.156 9.702 4.929 5.93c3.905-3.905 10.237-3.905 14.142 0 3.773 3.773 3.9 9.811.382 13.738a1 1 0 0 1-1.49-1.334 8 8 0 0 0-.306-10.99Zm-9.365 1.95a1 1 0 0 1 1.414 0l3 3a1 1 0 1 1-1.415 1.414l-3-3a1 1 0 0 1 0-1.414Z"
    })
  }));
};

var Database = function Database(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.801 4.894c-.277.232-.301.38-.301.425 0 .046.024.194.301.426.274.229.714.468 1.323.684 1.212.43 2.936.71 4.876.71 1.94 0 3.664-.28 4.876-.71.61-.216 1.05-.455 1.323-.684.277-.232.301-.38.301-.426 0-.046-.024-.193-.301-.425-.274-.229-.714-.469-1.323-.685C15.664 3.78 13.94 3.5 12 3.5c-1.94 0-3.664.28-4.876.71-.61.215-1.05.455-1.323.684ZM18.5 7.344a7.274 7.274 0 0 1-1.123.5c-1.412.5-3.313.795-5.377.795-2.064 0-3.965-.295-5.377-.796A7.272 7.272 0 0 1 5.5 7.344V12c0 .028.015.165.294.392.273.222.713.456 1.324.667 1.214.418 2.94.691 4.882.691 1.942 0 3.668-.273 4.882-.691.61-.21 1.051-.445 1.324-.667.28-.227.294-.364.294-.392V7.344ZM20 5.32c0-.663-.381-1.192-.838-1.575-.46-.386-1.082-.7-1.785-.948C15.965 2.296 14.064 2 12 2c-2.064 0-3.965.295-5.377.796-.703.249-1.324.562-1.785.948C4.381 4.127 4 4.656 4 5.32v13.362c0 .663.381 1.192.838 1.575.46.386 1.082.7 1.785.948 1.412.5 3.313.796 5.377.796 2.064 0 3.965-.295 5.377-.796.703-.249 1.324-.563 1.785-.948.457-.383.838-.912.838-1.575V5.319Zm-1.5 8.669c-.338.185-.72.348-1.129.489-1.41.486-3.309.773-5.371.773-2.062 0-3.961-.287-5.371-.773a7.35 7.35 0 0 1-1.129-.489v4.693c0 .046.024.193.301.425.274.229.714.468 1.323.684 1.212.43 2.936.71 4.876.71 1.94 0 3.664-.28 4.876-.71.61-.215 1.05-.455 1.323-.684.277-.232.301-.38.301-.425v-4.693Z"
    })
  }));
};

var Download = function Download(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 3a.75.75 0 0 1 .75.75v9.44l2.22-2.22a.75.75 0 1 1 1.06 1.06l-3.5 3.5a.75.75 0 0 1-1.06 0l-3.5-3.5a.75.75 0 1 1 1.06-1.06l2.22 2.22V3.75A.75.75 0 0 1 12 3ZM3.75 14a.75.75 0 0 1 .75.75v4.5c0 .138.112.25.25.25h14.5a.25.25 0 0 0 .25-.25v-4.5a.75.75 0 0 1 1.5 0v4.5A1.75 1.75 0 0 1 19.25 21H4.75A1.75 1.75 0 0 1 3 19.25v-4.5a.75.75 0 0 1 .75-.75Z"
    })
  }));
};

var Ellipsis = function Ellipsis(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M3.75 10.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5ZM12 10.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5ZM20.25 10.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Z"
    })
  }));
};

var External = function External(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 3.75a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-1.5 0V5.56l-7.97 7.97a.75.75 0 1 1-1.06-1.06l7.97-7.97h-4.69a.75.75 0 0 1-.75-.75ZM5.324 5H9.25a.75.75 0 1 1 0 1.5h-3.9c-.292 0-.467 0-.596.011a.628.628 0 0 0-.12.018.25.25 0 0 0-.105.104.626.626 0 0 0-.018.121c-.01.13-.011.304-.011.596v11.3c0 .292 0 .467.011.596a.625.625 0 0 0 .018.12.25.25 0 0 0 .104.105.638.638 0 0 0 .121.018c.13.01.304.011.596.011h11.3c.292 0 .467 0 .596-.011a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.105.636.636 0 0 0 .018-.12c.01-.13.011-.304.011-.596V14a.75.75 0 0 1 1.5 0v4.676c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016H5.324c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676A9.053 9.053 0 0 1 3 18.676V7.324c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C4.83 5 5.066 5 5.324 5ZM17.47 19.37v-.002Zm-.1.1h-.003Zm-12.74 0h.002Zm-.1-.102a.02.02 0 0 1 0 .001Zm0-12.737v.001Zm.102-.102h-.001Z"
    })
  }));
};

var Features = function Features(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.5 1a.75.75 0 0 1 .75.75c0 1.558.345 2.508.918 3.082.574.573 1.524.918 3.082.918a.75.75 0 0 1 0 1.5c-1.558 0-2.508.345-3.082.918-.573.574-.918 1.524-.918 3.082a.75.75 0 0 1-1.5 0c0-1.558-.345-2.508-.918-3.082-.574-.573-1.524-.918-3.082-.918a.75.75 0 0 1 0-1.5c1.558 0 2.508-.345 3.082-.918.573-.574.918-1.524.918-3.082A.75.75 0 0 1 6.5 1Zm0 4.106A3.944 3.944 0 0 1 5.106 6.5 3.944 3.944 0 0 1 6.5 7.894 3.944 3.944 0 0 1 7.894 6.5 3.944 3.944 0 0 1 6.5 5.106ZM15 7a.75.75 0 0 1 .75.75c0 2.426.536 4.001 1.517 4.983.982.981 2.557 1.517 4.983 1.517a.75.75 0 0 1 0 1.5c-2.426 0-4.001.536-4.983 1.517-.981.982-1.517 2.557-1.517 4.983a.75.75 0 0 1-1.5 0c0-2.426-.536-4.001-1.517-4.983-.982-.981-2.557-1.517-4.983-1.517a.75.75 0 0 1 0-1.5c2.426 0 4.001-.536 4.983-1.517.981-.982 1.517-2.557 1.517-4.983A.75.75 0 0 1 15 7Zm0 5.009a5.83 5.83 0 0 1-1.207 1.784A5.823 5.823 0 0 1 12.01 15c.68.301 1.277.7 1.784 1.207A5.823 5.823 0 0 1 15 17.99a5.83 5.83 0 0 1 1.207-1.784A5.823 5.823 0 0 1 17.99 15a5.823 5.823 0 0 1-1.784-1.207A5.823 5.823 0 0 1 15 12.01Z"
    })
  }));
};

var Filter = function Filter(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 5a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm3 7a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm3 7a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z"
    })
  }));
};

var Flag = function Flag(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M4.75 2a.75.75 0 0 0-.75.75v18.5a.75.75 0 0 0 1.5 0V15.5h14.75a.75.75 0 0 0 .624-1.166L17.151 8.75l3.723-5.584A.75.75 0 0 0 20.25 2H4.75Z"
    })
  }));
};

var Flask = function Flask(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 6.75A.75.75 0 0 1 7.75 6h8.5a.75.75 0 0 1 0 1.5H16v3.233a31.851 31.851 0 0 0 .885 1.006c.322.358.665.738.995 1.132.72.86 1.434 1.842 1.83 2.948.18.505.29 1.04.29 1.597A4.584 4.584 0 0 1 15.416 22H8.584A4.584 4.584 0 0 1 4 17.416c0-.558.11-1.092.29-1.597.396-1.106 1.11-2.089 1.83-2.948.33-.394.673-.774.995-1.132l.093-.104c.287-.317.553-.616.792-.902V7.5h-.25A.75.75 0 0 1 7 6.75Zm2.5.75v3.763l-.164.206c-.31.386-.662.78-1.013 1.17l-.091.101c-.325.361-.65.722-.962 1.095-.345.41-.66.82-.928 1.234l.098-.015c.895-.137 2.053-.275 2.99-.25 1.137.03 2 .302 2.774.545l.021.007c.779.245 1.469.46 2.384.484.797.02 1.846-.1 2.725-.234.211-.032.41-.065.59-.095-.313-.566-.728-1.12-1.194-1.676-.312-.373-.637-.734-.962-1.095l-.091-.101c-.351-.39-.703-.784-1.013-1.17l-.164-.206V7.5h-5Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M11 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm4-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
    })]
  }));
};

var Funnels = function Funnels(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M19.499 8a1.5 1.5 0 0 0 1.5-1.5v-2a1.5 1.5 0 0 0-1.5-1.5h-15a1.5 1.5 0 0 0-1.5 1.5v2a1.5 1.5 0 0 0 1.5 1.5h15Zm-4 5a1.5 1.5 0 0 1-1.5 1.5h-9.5a1.5 1.5 0 0 1-1.5-1.5v-2a1.5 1.5 0 0 1 1.5-1.5h9.5a1.5 1.5 0 0 1 1.5 1.5v2Zm-5.5 6.5a1.5 1.5 0 0 1-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5v-2a1.5 1.5 0 0 1 1.5-1.5h4a1.5 1.5 0 0 1 1.5 1.5v2Z"
    })
  }));
};

var Gear = function Gear(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 1a.75.75 0 0 1 .75.75v1.28a8.95 8.95 0 0 1 3.086.826l.64-1.108a.75.75 0 1 1 1.299.75l-.64 1.11a9.047 9.047 0 0 1 2.258 2.258l1.109-.64a.75.75 0 1 1 .75 1.298l-1.108.64c.448.95.735 1.99.825 3.086h1.281a.75.75 0 0 1 0 1.5h-1.28a8.95 8.95 0 0 1-.826 3.085l1.108.64a.75.75 0 0 1-.75 1.3l-1.11-.641a9.047 9.047 0 0 1-2.258 2.259l.64 1.109a.75.75 0 0 1-1.299.75l-.64-1.108a8.95 8.95 0 0 1-3.085.825v1.281a.75.75 0 0 1-1.5 0v-1.281a8.949 8.949 0 0 1-3.086-.825l-.64 1.108a.75.75 0 0 1-1.299-.75l.64-1.11a9.047 9.047 0 0 1-2.258-2.258l-1.109.64a.75.75 0 0 1-.75-1.299l1.108-.64a8.95 8.95 0 0 1-.825-3.085H1.75a.75.75 0 0 1 0-1.5h1.28a8.949 8.949 0 0 1 .826-3.086l-1.108-.64a.75.75 0 1 1 .75-1.299l1.11.64a9.046 9.046 0 0 1 2.258-2.258l-.64-1.109a.75.75 0 1 1 1.299-.75l.64 1.108a8.95 8.95 0 0 1 3.085-.825V1.75A.75.75 0 0 1 12 1ZM7.619 5.912A7.542 7.542 0 0 0 5.503 8.25 7.462 7.462 0 0 0 4.5 12c0 1.367.365 2.647 1.003 3.75a7.543 7.543 0 0 0 2.116 2.338l2.28-3.948A2.991 2.991 0 0 1 9 12c0-.839.344-1.597.898-2.14L7.62 5.911Zm3.578 3.197L8.917 5.16A7.47 7.47 0 0 1 12 4.5c1.368 0 2.648.365 3.75 1.003a7.54 7.54 0 0 1 2.747 2.747c.52.898.858 1.914.966 3h-4.558a3.001 3.001 0 0 0-3.708-2.141Zm3.709 3.64a3.001 3.001 0 0 1-3.71 2.142l-2.279 3.948A7.47 7.47 0 0 0 12 19.5a7.461 7.461 0 0 0 3.75-1.002 7.541 7.541 0 0 0 2.747-2.747c.52-.899.858-1.915.966-3h-4.558ZM12 10.5a1.5 1.5 0 1 0-.002 2.998A1.5 1.5 0 0 0 12 10.501Z"
    })
  }));
};

var GraduationCap = function GraduationCap(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M11.956 5.002a.707.707 0 0 0-.19.037L1.468 8.652a.703.703 0 0 0 0 1.323L5.242 11.3v5.098c0 .303.195.571.483.666l6.063 1.945a.701.701 0 0 0 .424 0l6.063-1.945a.702.702 0 0 0 .483-.666v-5.105l.65-.227a.703.703 0 1 0-.467-1.324L12 12.177 3.823 9.31 12 6.443l9.596 3.371v3.409a.702.702 0 1 0 1.404 0V9.31a.703.703 0 0 0-.468-.659L12.234 5.038a.701.701 0 0 0-.278-.036Zm-5.31 6.787 5.12 1.8a.698.698 0 0 0 .468 0l5.12-1.8v4.096L12 17.604l-5.354-1.72V11.79Z"
    })
  }));
};

var Graph = function Graph(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M11 3.001a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5h2a1.5 1.5 0 0 0 1.5-1.5v-15a1.5 1.5 0 0 0-1.5-1.5h-2Zm-6.5 10a1.5 1.5 0 0 0-1.5 1.5v5a1.5 1.5 0 0 0 1.5 1.5h2a1.5 1.5 0 0 0 1.5-1.5v-5a1.5 1.5 0 0 0-1.5-1.5h-2Zm11.5-3.5a1.5 1.5 0 0 1 1.5-1.5h2a1.5 1.5 0 0 1 1.5 1.5v10a1.5 1.5 0 0 1-1.5 1.5h-2a1.5 1.5 0 0 1-1.5-1.5v-10Z"
    })
  }));
};

var GridMasonry = function GridMasonry(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.324 3h4.926a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75h-6.5A.75.75 0 0 1 3 8.25V5.324c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C4.83 3 5.066 3 5.324 3ZM4.63 4.53h.001Zm.002-.001a.626.626 0 0 1 .121-.018c.13-.01.304-.011.596-.011H9.5v3h-5V5.35c0-.292 0-.467.011-.596a.626.626 0 0 1 .018-.12.25.25 0 0 1 .104-.105Zm-.103.102v.001Zm14.716-.12a8.336 8.336 0 0 0-.596-.011H14.5v7h5V5.35c0-.292 0-.467-.011-.596a.638.638 0 0 0-.018-.12.25.25 0 0 0-.105-.105.625.625 0 0 0-.12-.018Zm.123.019h-.001Zm.101.1v.002Zm-.102-1.614c.213.018.446.057.677.175.329.168.596.435.764.765.118.23.157.463.175.676.016.198.016.434.016.692v6.926a.75.75 0 0 1-.75.75h-6.5a.75.75 0 0 1-.75-.75v-8.5a.75.75 0 0 1 .75-.75h4.926c.258 0 .494 0 .692.016ZM3 11.75a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 .75.75v8.5a.75.75 0 0 1-.75.75H5.324c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676A9.053 9.053 0 0 1 3 18.676V11.75Zm1.5.75v6.15c0 .292 0 .467.011.596a.625.625 0 0 0 .018.12.25.25 0 0 0 .104.105.638.638 0 0 0 .121.018c.13.01.304.011.596.011H9.5v-7h-5Zm.13 6.97h.002Zm-.1-.1v-.002ZM13 15.75a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 .75.75v2.926c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016H13.75a.75.75 0 0 1-.75-.75v-4.5Zm1.5.75v3h4.15c.292 0 .467 0 .596-.011a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.105.636.636 0 0 0 .018-.12c.01-.13.011-.304.011-.596V16.5h-5Zm4.87 2.97h-.002Z"
    })
  }));
};

var HardDrive = function HardDrive(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      d: "M4 3.75C4 2.784 4.784 2 5.75 2h12.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 18.25 22H5.75A1.75 1.75 0 0 1 4 20.25V3.75Zm1.5 12v4.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-4.5a.25.25 0 0 0-.25-.25H5.75a.25.25 0 0 0-.25.25Zm13-1.732a1.762 1.762 0 0 0-.25-.018H5.75c-.085 0-.168.006-.25.018V3.75a.25.25 0 0 1 .25-.25h12.5a.25.25 0 0 1 .25.25v10.268Z",
      clipRule: "evenodd"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M16 18.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM13 18.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      d: "M16 19a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-3 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-.5-1a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Zm3 0a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Z",
      clipRule: "evenodd"
    })]
  }));
};

var Home = function Home(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.162 3.12a.25.25 0 0 0-.324 0l-7.25 6.152a.25.25 0 0 0-.088.191v9.787c0 .138.112.25.25.25h4a.25.25 0 0 0 .25-.25v-3.5c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v3.5c0 .138.112.25.25.25h4a.25.25 0 0 0 .25-.25V9.463a.25.25 0 0 0-.088-.19l-7.25-6.152Zm-1.294-1.143a1.75 1.75 0 0 1 2.264 0l7.25 6.152c.392.332.618.82.618 1.334v9.787A1.75 1.75 0 0 1 19.25 21h-4a1.75 1.75 0 0 1-1.75-1.75v-3.5a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25v3.5A1.75 1.75 0 0 1 8.75 21h-4A1.75 1.75 0 0 1 3 19.25V9.463c0-.514.226-1.002.618-1.334l7.25-6.152Z"
    })
  }));
};

var HogQL = function HogQL(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m21.153 11.076-1.73 1.968.513 2.57-1.788.605v.527l-2.32 1.541.01.084c.045.4.105.93.18 1.059.113.183.242.328.39.434.154.106.32.18.497.221.177.042.36.063.55.063.253 0 .504-.054.753-.16.254-.106.481-.254.682-.443l1.002 1.489c-.373.313-.78.552-1.224.718a3.706 3.706 0 0 1-1.32.248 5.32 5.32 0 0 1-1.498-.195 2.993 2.993 0 0 1-1.126-.603 2.676 2.676 0 0 1-.718-1.02 3.43 3.43 0 0 1-.18-.566l-1.75 1.163-6.072-4.033v-.527l-1.787-.606.513-2.569L3 11.076l1.73-1.968-.513-2.57 2.482-.84.84-2.481 2.57.513L12.078 2l1.968 1.73 2.57-.513.84 2.482 2.48.84-.513 2.569 1.73 1.968Zm-8.553 8.1 4.503-2.99v-2.974c0-2.866-2.01-5.026-4.677-5.026h-.698c-2.666 0-4.677 2.16-4.677 5.026v2.974l4.503 2.99V17.05h-.462a.523.523 0 0 1 0-1.046h1.969a.523.523 0 0 1 0 1.046H12.6v2.128Zm-2.637-4.958c0 1.386-2.079 1.386-2.079 0s2.08-1.386 2.08 0Zm6.311 0c0 1.386-2.079 1.386-2.079 0s2.08-1.386 2.08 0Z"
    })
  }));
};

var Info = function Info(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM10 11C10 10.5858 10.3358 10.25 10.75 10.25H12C12.4142 10.25 12.75 10.5858 12.75 11L12.75 16.25C12.75 16.6642 12.4142 17 12 17C11.5858 17 11.25 16.6642 11.25 16.25L11.25 11.75H10.75C10.3358 11.75 10 11.4142 10 11Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M11.5 8C11.5 7.72386 11.7239 7.5 12 7.5V7.5C12.2761 7.5 12.5 7.72386 12.5 8V8C12.5 8.27614 12.2761 8.5 12 8.5V8.5C11.7239 8.5 11.5 8.27614 11.5 8V8Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 8.75C11.5858 8.75 11.25 8.41421 11.25 8C11.25 7.58579 11.5858 7.25 12 7.25C12.4142 7.25 12.75 7.58579 12.75 8C12.75 8.41421 12.4142 8.75 12 8.75ZM12 7.5C11.7239 7.5 11.5 7.72386 11.5 8C11.5 8.27614 11.7239 8.5 12 8.5C12.2761 8.5 12.5 8.27614 12.5 8C12.5 7.72386 12.2761 7.5 12 7.5Z"
    })]
  }));
};

var Laptop = function Laptop(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 5.75A2.75 2.75 0 0 1 5.75 3h12.5A2.75 2.75 0 0 1 21 5.75V16h1.25a.75.75 0 0 1 .75.75v1.5A2.75 2.75 0 0 1 20.25 21H3.75A2.75 2.75 0 0 1 1 18.25v-1.5a.75.75 0 0 1 .75-.75H3V5.75ZM4.5 16h15V5.75c0-.69-.56-1.25-1.25-1.25H5.75c-.69 0-1.25.56-1.25 1.25V16Zm-2 1.5v.75c0 .69.56 1.25 1.25 1.25h16.5c.69 0 1.25-.56 1.25-1.25v-.75h-19Z"
    })
  }));
};

var Lifecycle = function Lifecycle(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M2 2a1 1 0 0 1 1-1h3.556a1 1 0 0 1 1 1v7.89H2V2ZM2 11.14h5.556v10.11a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V11.14ZM9.224 5.333a1 1 0 0 1 1-1h3.556a1 1 0 0 1 1 1V9.89H9.224V5.333ZM9.227 11.14h5.555v5.666a1 1 0 0 1-1 1h-3.555a1 1 0 0 1-1-1V11.14ZM16.444 11.14h5.555v3.444a1 1 0 0 1-1 1h-3.555a1 1 0 0 1-1-1v-3.445ZM16.444 9.89H22V4.221a1 1 0 0 0-1-1h-3.556a1 1 0 0 0-1 1V9.89Z"
    })
  }));
};

var LightBulb = function LightBulb(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9991 3.5C8.40878 3.5 5.49823 6.41055 5.49823 10.0009C5.49823 12.1006 6.49288 13.9677 8.0398 15.1574C8.21999 15.296 8.4076 15.4253 8.60193 15.5447C9.08959 15.8443 9.45922 16.3712 9.49508 17H14.5032C14.539 16.3712 14.9086 15.8443 15.3963 15.5447C15.5906 15.4253 15.7782 15.296 15.9584 15.1574C17.5053 13.9677 18.5 12.1006 18.5 10.0009C18.5 6.41055 15.5895 3.5 11.9991 3.5ZM14.5003 18.5H9.49793V18.9988C9.49793 20.3802 10.6178 21.5 11.9991 21.5C13.3805 21.5 14.5003 20.3802 14.5003 18.9988V18.5ZM3.99823 10.0009C3.99823 5.58212 7.58035 2 11.9991 2C16.4179 2 20 5.58212 20 10.0009C20 12.5861 18.7731 14.885 16.8729 16.3465C16.6513 16.5169 16.4205 16.6759 16.1814 16.8228C16.0505 16.9032 16.0003 17.0173 16.0003 17.1005V18.9988C16.0003 21.2086 14.2089 23 11.9991 23C9.78932 23 7.99793 21.2086 7.99793 18.9988V17.1005C7.99793 17.0173 7.94769 16.9032 7.81683 16.8228C7.57769 16.6759 7.3469 16.5169 7.12534 16.3465C5.22513 14.885 3.99823 12.5861 3.99823 10.0009Z"
    })
  }));
};

var Logomark = function Logomark(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsxs("g", {
      clipPath: "url(#icon/logomark__a)",
      children: [/* @__PURE__ */jsxRuntimeExports.jsx("path", {
        d: "M5.722 12.713a.36.36 0 0 1-.644 0L4.6 11.76a.36.36 0 0 1 0-.322l.478-.954a.36.36 0 0 1 .644 0l.477.954a.36.36 0 0 1 0 .322l-.477.954Zm0 4.399a.36.36 0 0 1-.644 0l-.478-.954a.36.36 0 0 1 0-.322l.478-.955a.36.36 0 0 1 .644 0l.477.955a.36.36 0 0 1 0 .322l-.477.954Z"
      }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
        d: "M1 15.106a.36.36 0 0 1 .614-.254l2.29 2.29a.36.36 0 0 1-.254.614H1.36a.36.36 0 0 1-.36-.36v-2.29Zm0-1.898a.36.36 0 0 0 .105.255l4.188 4.188a.36.36 0 0 0 .255.105h2.5a.36.36 0 0 0 .255-.614l-6.689-6.689a.36.36 0 0 0-.614.255v2.5ZM1 8.81a.36.36 0 0 0 .105.254l8.587 8.587a.36.36 0 0 0 .254.105h2.501a.36.36 0 0 0 .255-.614L1.614 6.054A.36.36 0 0 0 1 6.31v2.5Zm4.399 0a.36.36 0 0 0 .105.254l8.077 8.078a.36.36 0 0 0 .615-.255v-2.5a.36.36 0 0 0-.105-.255L6.013 6.054a.36.36 0 0 0-.614.255v2.5Zm5.013-2.756a.36.36 0 0 0-.615.255v2.5a.36.36 0 0 0 .106.255l3.678 3.679a.36.36 0 0 0 .615-.255v-2.5a.36.36 0 0 0-.105-.255l-3.68-3.679Zm9.298 9.299-4.279-4.278a.36.36 0 0 0-.614.255v6.066c0 .199.16.36.36.36h6.575a.36.36 0 0 0 .36-.36v-.688a.392.392 0 0 0-.36-.379 3.398 3.398 0 0 1-2.043-.976Zm-2.782.996a.704.704 0 1 1 0-1.409.704.704 0 0 1 0 1.409Z"
      }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
        d: "M1 17.396c0 .199.161.36.36.36h2.29a.36.36 0 0 0 .254-.614l-2.29-2.29a.36.36 0 0 0-.614.254v2.29Zm4.399-7.558L1.614 6.054A.36.36 0 0 0 1 6.31v2.5a.36.36 0 0 0 .105.255L5.4 13.357V9.84Zm-3.785.615a.36.36 0 0 0-.614.255v2.5a.36.36 0 0 0 .105.255L5.4 17.756v-3.519l-3.785-3.784Zm8.185-.465a.36.36 0 0 0-.106-.255L6.014 6.054a.36.36 0 0 0-.614.255v2.5a.36.36 0 0 0 .105.255L9.8 13.357v-3.37ZM5.4 17.756h2.65a.36.36 0 0 0 .254-.614L5.4 14.237v3.52Z"
      }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
        d: "M5.4 9.839v3.37a.36.36 0 0 0 .105.254L9.8 17.756v-3.37a.36.36 0 0 0-.106-.254L5.4 9.839Z"
      })]
    }), /* @__PURE__ */jsxRuntimeExports.jsx("defs", {
      children: /* @__PURE__ */jsxRuntimeExports.jsx("clipPath", {
        id: "icon/logomark__a",
        children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
          transform: "translate(1 5)",
          d: "M0 0h22v13.444H0z"
        })
      })
    })]
  }));
};

var Magic = function Magic(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      d: "M5 13.163a5.585 5.585 0 0 1-.552-.223 3.094 3.094 0 0 1-.844-.565C3.335 12.113 3 11.65 3 11s.335-1.112.604-1.375c.266-.26.578-.439.844-.565.54-.255 1.227-.446 1.955-.591C7.883 8.173 9.86 8 12 8c2.139 0 4.117.173 5.598.469.727.145 1.413.336 1.954.591.266.126.578.305.844.565.269.263.604.726.604 1.375 0 .65-.335 1.113-.604 1.375-.266.26-.578.44-.844.565a5.58 5.58 0 0 1-.552.223V19c0 .615-.348 1.1-.755 1.447-.41.349-.959.63-1.572.85C15.443 21.74 13.79 22 12 22c-1.79 0-3.442-.26-4.673-.703-.613-.22-1.162-.501-1.572-.85C5.348 20.101 5 19.615 5 19v-5.837Zm13.332-1.359h.003c.738-.233 1.165-.508 1.165-.804 0-.295-.427-.57-1.165-.803l-.003-.001C17.002 9.778 14.662 9.5 12 9.5c-2.663 0-5.001.278-6.332.696l-.003.001c-.738.232-1.165.508-1.165.803 0 .296.427.571 1.165.803l.003.001c1.33.419 3.67.696 6.332.696 2.663 0 5.001-.277 6.332-.696Zm-.832 1.747c-1.47.284-3.408.45-5.5.45s-4.03-.166-5.5-.45V19c0 .006.002.112.227.304.223.19.59.394 1.108.58 1.03.371 2.502.615 4.165.615 1.663 0 3.135-.244 4.165-.614.519-.187.885-.392 1.108-.581.225-.192.227-.298.227-.305v-5.45Z",
      clipRule: "evenodd"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M13.553 1.895a.5.5 0 0 1 .894 0c.496.991.667 1.162 1.659 1.658a.5.5 0 0 1 0 .894c-.992.496-1.163.667-1.659 1.659a.5.5 0 0 1-.894 0c-.496-.992-.667-1.163-1.659-1.659a.5.5 0 0 1 0-.894c.992-.496 1.163-.667 1.659-1.658ZM8.553 3.895a.5.5 0 0 1 .894 0c.174.348.31.484.659.658a.5.5 0 0 1 0 .894c-.349.175-.485.31-.659.659a.5.5 0 0 1-.894 0c-.174-.349-.31-.484-.659-.659a.5.5 0 0 1 0-.894c.349-.174.485-.31.659-.658Z"
    })]
  }));
};

var Map$1 = function Map$1(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 6.25A3.25 3.25 0 0 1 5.25 3h2.5v3h3a.75.75 0 0 1 0 1.5h-3v7.75A.75.75 0 0 1 7 16H5.25a1.75 1.75 0 1 0 0 3.5h14a.25.25 0 0 0 .25-.25v-6.5a.75.75 0 0 1 1.5 0v6.5A1.75 1.75 0 0 1 19.25 21h-14A3.25 3.25 0 0 1 2 17.75V6.25Zm1.5 8.76a3.235 3.235 0 0 1 1.75-.51h1v-10h-1A1.75 1.75 0 0 0 3.5 6.25v8.76ZM17 4.5c-1.389 0-2.5 1.111-2.5 2.464 0 1.025.626 1.91 1.379 2.592A7.483 7.483 0 0 0 17 10.39l.107-.067a7.483 7.483 0 0 0 1.014-.767c.753-.682 1.379-1.567 1.379-2.592C19.5 5.611 18.389 4.5 17 4.5Zm0 6.75-.333.672h-.002l-.003-.003-.01-.005-.036-.018a8.14 8.14 0 0 1-.525-.305 8.977 8.977 0 0 1-1.22-.924C14 9.877 13 8.617 13 6.964 13 4.767 14.799 3 17 3s4 1.767 4 3.964c0 1.654-.999 2.912-1.871 3.703a8.977 8.977 0 0 1-1.745 1.23l-.035.017-.01.005-.004.002h-.002L17 11.25Zm0 0 .332.672a.751.751 0 0 1-.665 0L17 11.25Z"
    })
  }));
};

var Message = function Message(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.409 5.366C6.273 3.806 8.899 3 12 3s5.727.805 7.591 2.366C21.471 6.941 22.5 9.223 22.5 12s-1.03 5.059-2.909 6.634C17.727 20.194 15.101 21 12 21c-1.693 0-3.57-.162-5.234-.922a6.967 6.967 0 0 1-1.223.568c-.941.328-2.282.548-3.615-.086a.75.75 0 0 1-.277-1.129c1.443-1.912 1.015-3.08.997-3.13l-.006-.014-.008-.019-.012-.028a22.19 22.19 0 0 1-.608-1.665c-.25-.782-.514-1.78-.514-2.575 0-2.777 1.03-5.059 2.909-6.634Zm1.864 13.249a.75.75 0 0 1 .795-.06c1.426.754 3.17.945 4.932.945 2.857 0 5.106-.742 6.628-2.016C20.133 16.222 21 14.379 21 12c0-2.38-.867-4.223-2.372-5.484C17.106 5.242 14.857 4.5 12 4.5s-5.106.742-6.628 2.016C3.867 7.777 3 9.62 3 12c0 .542.196 1.346.443 2.12.239.749.496 1.38.564 1.545l.002.004c.007.017.03.071.047.116.157.427.468 1.776-.618 3.663.56.06 1.117-.046 1.611-.219a5.462 5.462 0 0 0 1.212-.606l.012-.008Zm.001-.001Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M7.5 12.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm4.5 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm4.5 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.5 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm4.5 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm4.5 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-9-.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm4.5 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm4-.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Z"
    })]
  }));
};

var Multiply = function Multiply(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.22 7.22a.75.75 0 0 1 1.06 0L12 10.94l3.72-3.72a.75.75 0 1 1 1.06 1.06L13.06 12l3.72 3.72a.75.75 0 1 1-1.06 1.06L12 13.06l-3.72 3.72a.75.75 0 0 1-1.06-1.06L10.94 12 7.22 8.28a.75.75 0 0 1 0-1.06Z"
    })
  }));
};

var Newspaper = function Newspaper(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 4.75C2 3.784 2.784 3 3.75 3h11.5c.966 0 1.75.784 1.75 1.75v6.5h3.25c.966 0 1.75.784 1.75 1.75v4.75a3.25 3.25 0 0 1-3.419 3.246.773.773 0 0 1-.081.004H5.25A3.25 3.25 0 0 1 2 17.75v-13ZM16.01 19.5a3.235 3.235 0 0 1-.51-1.75v-13a.25.25 0 0 0-.25-.25H3.75a.25.25 0 0 0-.25.25v13c0 .966.784 1.75 1.75 1.75h10.76Zm.99-6.75v5a1.75 1.75 0 1 0 3.5 0V13a.25.25 0 0 0-.25-.25H17Zm-11-5A.75.75 0 0 1 6.75 7h5.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1-.75-.75v-4.5Zm1.5.75v3h4v-3h-4ZM6 15.75a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Z"
    })
  }));
};

var People = function People(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.5 4.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM3.5 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm13-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm-4 2.5a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm6.692 7.268c-1.381-.87-3.024-1-4.48-.395a.75.75 0 0 1-.575-1.385 6.342 6.342 0 0 1 5.855.511c1.796 1.133 3.171 3.188 3.628 6.067.17 1.073-.698 1.934-1.693 1.934H16.75a.75.75 0 0 1 0-1.5h5.177a.23.23 0 0 0 .172-.072.145.145 0 0 0 .04-.127c-.4-2.52-1.571-4.165-2.947-5.033ZM7.429 13.5c-2.384 0-4.934 1.811-5.567 5.798a.149.149 0 0 0 .04.13.228.228 0 0 0 .171.072h10.711c.073 0 .133-.03.17-.073a.149.149 0 0 0 .041-.129c-.633-3.987-3.183-5.798-5.566-5.798Zm0-1.5c3.243 0 6.319 2.476 7.047 7.063.17 1.07-.694 1.937-1.692 1.937H2.073c-.998 0-1.862-.867-1.692-1.937C1.109 14.476 4.185 12 7.429 12Z"
    })
  }));
};

var Percentage = function Percentage(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      d: "M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm14.53-4.53a.75.75 0 0 1 0 1.06l-8 8a.75.75 0 0 1-1.06-1.06l8-8a.75.75 0 0 1 1.06 0Z",
      clipRule: "evenodd"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M9 9.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      d: "M9 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-.5-1a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Z",
      clipRule: "evenodd"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M15 15.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      d: "M15 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-.5-1a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Z",
      clipRule: "evenodd"
    })]
  }));
};

var Person = function Person(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 3.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-4.5 3a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM12 14c-3.418 0-5.905 2.253-6.597 5.33a.103.103 0 0 0 0 .052c.004.013.011.03.027.048.033.037.091.07.168.07h12.804a.223.223 0 0 0 .168-.07.103.103 0 0 0 .027-.1C17.905 16.253 15.417 14 12 14Zm-8.06 5.001C4.773 15.294 7.827 12.5 12 12.5s7.227 2.794 8.06 6.501C20.31 20.112 19.4 21 18.402 21H5.598c-.998 0-1.908-.888-1.658-1.999Z"
    })
  }));
};

var Privacy = function Privacy(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 4.75C3 3.784 3.784 3 4.75 3h14.5c.966 0 1.75.784 1.75 1.75v12.406c0 .64-.35 1.23-.912 1.537l-7.25 3.954a1.75 1.75 0 0 1-1.676 0l-7.25-3.954A1.75 1.75 0 0 1 3 17.156V4.75Zm1.75-.25a.25.25 0 0 0-.25.25v12.406c0 .092.05.176.13.22l7.25 3.954a.25.25 0 0 0 .24 0l7.25-3.954a.25.25 0 0 0 .13-.22V4.75a.25.25 0 0 0-.25-.25H4.75Zm10.28 5.22a.75.75 0 0 1 0 1.06l-3.5 3.5a.75.75 0 0 1-1.06 0l-1.5-1.5a.75.75 0 1 1 1.06-1.06l.97.97 2.97-2.97a.75.75 0 0 1 1.06 0Z"
    })
  }));
};

var Profile = function Profile(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 2.75A.75.75 0 0 1 2.75 2h14.5a.75.75 0 0 1 .75.75V6h3.25a.75.75 0 0 1 .75.75v14.5a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V18H2.75a.75.75 0 0 1-.75-.75V2.75ZM7.5 20.5h1.245c.719-2.3 2.778-4 5.255-4s4.536 1.7 5.255 4H20.5v-13h-13v13Zm9-14.5H6.75a.75.75 0 0 0-.75.75v9.75H3.5v-13h13V6Zm1.158 14.5C17.012 19.008 15.599 18 14 18c-1.599 0-3.012 1.008-3.658 2.5h7.316ZM14 11a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-3 1.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z"
    })
  }));
};

var Pulse = function Pulse(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M6.936 11.277 8.99 4.77l5.05 16.414c.29.945 1.63.94 1.914-.007l2.55-8.499a.25.25 0 0 1 .239-.178h3.506a.75.75 0 0 0 0-1.5h-3.506a1.75 1.75 0 0 0-1.676 1.247L14.99 19.17 9.953 2.796c-.289-.938-1.614-.943-1.91-.007l-2.537 8.036a.25.25 0 0 1-.239.175H1.75a.75.75 0 0 0 0 1.5h3.517a1.75 1.75 0 0 0 1.669-1.223Z"
    })
  }));
};

var Question = function Question(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 9a1 1 0 0 0-.879.522 1 1 0 1 1-1.754-.96A3 3 0 0 1 12 7c1.515 0 2.567 1.006 2.866 2.189.302 1.189-.156 2.574-1.524 3.258A.618.618 0 0 0 13 13a1 1 0 1 1-2 0c0-.992.56-1.898 1.447-2.342.455-.227.572-.618.48-.978C12.836 9.314 12.529 9 12 9Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M13 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    })]
  }));
};

var Quote = function Quote(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 5.75C2 4.784 2.784 4 3.75 4h5.5c.964 0 1.75.78 1.75 1.748v7.288c0 2.572-1.113 4.31-2.228 5.393a7.929 7.929 0 0 1-1.52 1.154 6.704 6.704 0 0 1-.708.357l-.014.006-.005.002h-.002c-.001.001-.001.001-.273-.698l.272.7a.75.75 0 0 1-1.022-.7v-5.464H3.75A1.75 1.75 0 0 1 2 12.036V5.75Zm5 12.21c.23-.164.479-.366.728-.608.885-.859 1.772-2.228 1.772-4.316V5.748a.248.248 0 0 0-.25-.248h-5.5a.25.25 0 0 0-.25.25v6.286c0 .138.112.25.25.25h2.5a.75.75 0 0 1 .75.75v4.924Zm6-12.21c0-.966.784-1.75 1.75-1.75h5.5c.965 0 1.75.78 1.75 1.748v7.288c0 2.572-1.113 4.31-2.227 5.393a7.927 7.927 0 0 1-1.52 1.154 6.701 6.701 0 0 1-.709.357l-.014.006-.005.002h-.002c-.001.001-.002.001-.273-.698l.271.7a.75.75 0 0 1-1.021-.7v-5.464h-1.75a1.75 1.75 0 0 1-1.75-1.75V5.75Zm5 12.21c.23-.164.479-.366.727-.608.886-.859 1.773-2.228 1.773-4.316V5.748a.248.248 0 0 0-.25-.248h-5.5a.25.25 0 0 0-.25.25v6.286c0 .138.112.25.25.25h2.5a.75.75 0 0 1 .75.75v4.924Z"
    })
  }));
};

var Receipt = function Receipt(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 3.75C4 2.784 4.784 2 5.75 2h12.5c.966 0 1.75.784 1.75 1.75v17.5a.75.75 0 0 1-1.243.566l-2.065-1.799-1.838 1.773a.75.75 0 0 1-1.041 0L12 20.042l-1.813 1.748a.75.75 0 0 1-1.04 0l-1.84-1.773-2.064 1.799A.75.75 0 0 1 4 21.25V3.75Zm1.75-.25a.25.25 0 0 0-.25.25v15.852l1.34-1.168a.75.75 0 0 1 1.014.026l1.813 1.748 1.812-1.748a.75.75 0 0 1 1.042 0l1.812 1.748 1.813-1.748a.75.75 0 0 1 1.013-.026l1.341 1.168V3.75a.25.25 0 0 0-.25-.25H5.75ZM8 7.75A.75.75 0 0 1 8.75 7h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 8 7.75Zm0 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
    })
  }));
};

var Retention = function Retention(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("g", {
      fillRule: "evenodd",
      clipPath: "url(#a)",
      clipRule: "evenodd",
      children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
        d: "m22 12.87-2.995-2.996-2.706 3.269 2.996 2.995L22 12.87ZM10.856 7.717l3.286-2.721L11.146 2 7.861 4.706l2.995 3.01ZM15.222 14.448l-1.642 1.98c-1.498 1.788-4.348 1.642-5.99 0-1.66-1.659-1.805-4.509 0-6.006l1.948-1.61L6.558 5.8l-1.98 1.626c-3.575 2.98-3.285 8.696 0 11.997 3.3 3.3 9.018 3.59 11.997 0L18.2 17.46l-2.98-3.011Z"
      })
    }), /* @__PURE__ */jsxRuntimeExports.jsx("defs", {
      children: /* @__PURE__ */jsxRuntimeExports.jsx("clipPath", {
        id: "a",
        children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
          d: "M2 2h20v20H2z"
        })
      })
    })]
  }));
};

var Rewind = function Rewind(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M13 .786a.785.785 0 0 0-.46-.712.812.812 0 0 0-.852.108l-2.4 1.964A.78.78 0 0 0 9 2.75a.78.78 0 0 0 .288.604l2.4 1.964c.238.195.57.237.851.108A.785.785 0 0 0 13 4.714V3.558A8.501 8.501 0 0 1 12 20.5 8.5 8.5 0 0 1 5.801 6.184a.75.75 0 0 0-1.094-1.026A9.968 9.968 0 0 0 2 12c0 5.523 4.477 10 10 10s10-4.477 10-10c0-5.185-3.947-9.449-9-9.95V.785Z"
    })
  }));
};

var RewindPlay = function RewindPlay(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("g", {
      clipPath: "url(#icon/rewind__a)",
      children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13 .857a.863.863 0 0 0-.46-.776.758.758 0 0 0-.852.118l-2.4 2.143A.883.883 0 0 0 9 3c0 .254.105.496.288.658l2.4 2.143c.238.213.57.26.851.118A.863.863 0 0 0 13 5.143V4.062A8.001 8.001 0 0 1 12 20 8 8 0 0 1 5.777 6.972a1 1 0 0 0-1.554-1.258A9.962 9.962 0 0 0 2 12c0 5.523 4.477 10 10 10s10-4.477 10-10c0-5.185-3.947-9.449-9-9.95V.856ZM9 8.703c0-.547.611-.884 1.09-.6l5.564 3.297a.693.693 0 0 1 0 1.2l-5.565 3.297c-.478.284-1.089-.053-1.089-.6V8.703Z"
      })
    }), /* @__PURE__ */jsxRuntimeExports.jsx("defs", {
      children: /* @__PURE__ */jsxRuntimeExports.jsx("clipPath", {
        id: "icon/rewind__a",
        children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
          d: "M0 0h24v24H0z"
        })
      })
    })]
  }));
};

var Ribbon = function Ribbon(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM4 9a8 8 0 1 1 13 6.245v7.005a.75.75 0 0 1-1.07.679L12 21.079l-3.93 1.85A.75.75 0 0 1 7 22.25v-7.005A7.985 7.985 0 0 1 4 9Zm4.5 7.196v4.872l3.18-1.497a.75.75 0 0 1 .64 0l3.18 1.497v-4.872A7.969 7.969 0 0 1 12 17a7.969 7.969 0 0 1-3.5-.804Z"
    })
  }));
};

var Rocket = function Rocket(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M4.528 17.25 1.75 20.107m5-.571L5.083 21.25m-2.333-9s3.77 1.77 5.5 3.5 3.5 5.5 3.5 5.5l3.18-2.953a1 1 0 0 0 .32-.733V15c4-2 6.5-5.25 6-12.25-7-.5-10.25 2-12.25 6H6.436a1 1 0 0 0-.733.32L2.75 12.25Zm14.5-3.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
};

var Sampling = function Sampling(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M11 16a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      d: "M11 4.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM3 11a8 8 0 1 1 14.162 5.102l3.618 3.618a.75.75 0 1 1-1.06 1.06l-3.618-3.618A8 8 0 0 1 3 11Z",
      clipRule: "evenodd"
    })]
  }));
};

var Search = function Search(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 4.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM3 11a8 8 0 1 1 14.162 5.102l3.618 3.618a.75.75 0 1 1-1.06 1.06l-3.618-3.618A8 8 0 0 1 3 11Z"
    })
  }));
};

var Send = function Send(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.325 3.097c.974-.32 1.898.604 1.578 1.578l-5.688 17.281c-.383 1.166-2.042 1.139-2.387-.04l-2.432-8.312-8.313-2.432c-1.178-.345-1.205-2.004-.04-2.387l17.282-5.688Zm-.002 1.58L3.277 9.958l7.671 2.245c.41.12.729.44.849.849l2.245 7.671 5.281-16.046Z"
    })
  }));
};

var Server = function Server(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 5.75C2 4.784 2.784 4 3.75 4h16.5c.966 0 1.75.784 1.75 1.75v12.5A1.75 1.75 0 0 1 20.25 20H3.75A1.75 1.75 0 0 1 2 18.25V5.75Zm1.75-.25a.25.25 0 0 0-.25.25v5.5h17v-5.5a.25.25 0 0 0-.25-.25H3.75Zm16.75 7.25h-17v5.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25v-5.5Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M7 8.375a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 7.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.5 8.375a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0 7.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1-6.75a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm0 7.25a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
    })]
  }));
};

var Share = function Share(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.22 3.72a.75.75 0 0 1 1.06 0l3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5a.75.75 0 1 1-1.06-1.06l2.22-2.22h-5.69a4.25 4.25 0 0 0-4.25 4.25v1a.75.75 0 0 1-1.5 0v-1A5.75 5.75 0 0 1 12.75 7h5.69l-2.22-2.22a.75.75 0 0 1 0-1.06ZM2.75 7a.75.75 0 0 1 .75.75v10.5c0 .138.112.25.25.25h15.5a.75.75 0 0 1 0 1.5H3.75A1.75 1.75 0 0 1 2 18.25V7.75A.75.75 0 0 1 2.75 7Z"
    })
  }));
};

var Shield = function Shield(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.0976 3.10613C12.0352 3.07966 11.9648 3.07965 11.9024 3.10613L4.65236 6.18189C4.55999 6.22107 4.5 6.31169 4.5 6.41203V13C4.5 17.1421 7.85786 20.5 12 20.5C16.1421 20.5 19.5 17.1421 19.5 13V6.41203C19.5 6.31169 19.44 6.22107 19.3476 6.18189L12.0976 3.10613ZM11.3165 1.72526C11.7533 1.53995 12.2467 1.53995 12.6835 1.72525L19.9335 4.80101C20.5801 5.07533 21 5.70965 21 6.41203V13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13V6.41203C3 5.70965 3.41994 5.07533 4.06654 4.80101L11.3165 1.72526ZM15.7702 9.20976C16.0686 9.49708 16.0776 9.97187 15.7902 10.2702L11.4569 14.7702C11.3155 14.9171 11.1205 15 10.9167 15C10.7128 15 10.5178 14.9171 10.3764 14.7702L8.20976 12.5202C7.92244 12.2219 7.9314 11.7471 8.22977 11.4598C8.52814 11.1724 9.00292 11.1814 9.29024 11.4798L10.9167 13.1688L14.7098 9.22977C14.9971 8.93141 15.4719 8.92245 15.7702 9.20976Z"
    })
  }));
};

var Stack = function Stack(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.123 3.315a2 2 0 0 1 1.754 0l7.97 3.887c1.497.731 1.497 2.865 0 3.596L18.38 12l2.465 1.203c1.498.73 1.498 2.864 0 3.595l-7.969 3.887a2 2 0 0 1-1.754 0l-7.969-3.887c-1.497-.73-1.497-2.865 0-3.595L5.62 12l-2.465-1.202c-1.497-.73-1.497-2.865 0-3.596l7.97-3.887ZM7.9 13.113 4.031 15l7.97 3.887L19.97 15l-3.87-1.887-3.223 1.572a2 2 0 0 1-1.754 0L7.9 13.113Zm4.1-8L4.031 9l7.97 3.887L19.97 9 12 5.113Z"
    })
  }));
};

var Stickiness = function Stickiness(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M2.706 12.754h.25a9.152 9.152 0 0 0 6.21 7.842.235.235 0 0 0 .244-.385l-.192-.204a1.18 1.18 0 0 1-.003-1.612l.887-.937a.236.236 0 0 0-.085-.38 5.527 5.527 0 0 1-3.44-4.324h.315a.705.705 0 0 0 .485-1.216l-2.093-1.98a.7.7 0 0 0-.968 0l-2.096 1.98a.705.705 0 0 0 .485 1.216h.001Z",
      opacity: ".5"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M12.312 16.451a.7.7 0 0 0-.772.171l-1.982 2.094a.707.707 0 0 0 0 .969l1.982 2.092a.704.704 0 0 0 1.216-.484v-.275a9.15 9.15 0 0 0 7.868-6.213.235.235 0 0 0-.384-.244l-.233.22a1.173 1.173 0 0 1-1.613-.002l-.924-.872a.237.237 0 0 0-.38.084 5.531 5.531 0 0 1-4.334 3.406v-.291a.7.7 0 0 0-.444-.655Z",
      opacity: ".6"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M14.783 3.99c.425.452.426 1.158.003 1.612l-.85.897a.237.237 0 0 0 .084.38 5.53 5.53 0 0 1 3.41 4.364h-.322a.705.705 0 0 0-.485 1.217l2.094 1.98c.27.257.697.257.968 0l2.095-1.98v-.001a.703.703 0 0 0-.486-1.216h-.243a9.134 9.134 0 0 0-6.293-7.921.237.237 0 0 0-.267.1.237.237 0 0 0 .025.285l.267.282Z",
      opacity: ".8"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M3.45 9.487c.09.057.208.045.286-.028l.258-.244a1.172 1.172 0 0 1 1.616.005l.904.855a.238.238 0 0 0 .38-.086 5.513 5.513 0 0 1 4.35-3.443v.345a.704.704 0 0 0 1.216.484l1.982-2.093a.707.707 0 0 0 0-.968L12.46 2.22a.705.705 0 0 0-1.216.484v.22A9.138 9.138 0 0 0 3.35 9.216a.234.234 0 0 0 .099.27Z"
    })]
  }));
};

var Store = function Store(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      d: "M4.939 3.682A1.75 1.75 0 0 1 6.325 3h11.35a1.75 1.75 0 0 1 1.386.682l2.783 3.612a.75.75 0 0 1 .156.458v1c0 .99-.393 1.89-1.028 2.556v7.942a1.75 1.75 0 0 1-1.75 1.75H4.778a1.75 1.75 0 0 1-1.75-1.75v-7.942A3.697 3.697 0 0 1 2 8.752v-1a.75.75 0 0 1 .156-.458l2.783-3.612Zm-.411 8.598v6.97c0 .138.112.25.25.25h4.416v-2.251c0-1.538 1.276-2.751 2.806-2.751s2.806 1.213 2.806 2.75V19.5h4.416a.25.25 0 0 0 .25-.25v-6.97a3.903 3.903 0 0 1-1.305.223 3.863 3.863 0 0 1-3.084-1.52A3.863 3.863 0 0 1 12 12.502a3.863 3.863 0 0 1-3.083-1.52 3.863 3.863 0 0 1-3.084 1.52c-.457 0-.897-.078-1.305-.223Zm5.139-3.528c0 1.224 1.025 2.251 2.333 2.251 1.308 0 2.333-1.027 2.333-2.25v-.251H9.667v.25Zm-1.5-.25v.25c0 1.224-1.026 2.251-2.334 2.251a2.37 2.37 0 0 1-1.563-.58 2.21 2.21 0 0 1-.77-1.67v-.251h4.667Zm11.558-1.5-1.852-2.405a.25.25 0 0 0-.198-.097H6.325a.25.25 0 0 0-.198.097L4.275 7.002h15.45Zm.775 1.5h-4.667v.25c0 1.224 1.026 2.251 2.334 2.251.604 0 1.15-.22 1.563-.58a2.21 2.21 0 0 0 .77-1.67v-.251ZM13.306 19.5v-2.251c0-.672-.566-1.251-1.306-1.251-.74 0-1.306.579-1.306 1.25V19.5h2.611Z",
      clipRule: "evenodd"
    })
  }));
};

var Target = function Target(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M18.593 2.189a1 1 0 0 0-1.682-.393l-2.932 3.1a1.75 1.75 0 0 0-.479 1.202v3.341l-2.03 2.03a.75.75 0 0 0 1.06 1.061l2.03-2.03h3.342a1.75 1.75 0 0 0 1.203-.479l3.099-2.932a1 1 0 0 0-.393-1.682l-2.46-.757-.758-2.461Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M3.5 12a8.5 8.5 0 0 1 8.96-8.488.75.75 0 0 0 .08-1.498C12.36 2.004 12.18 2 12 2 6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10c0-.181-.005-.361-.014-.54a.75.75 0 0 0-1.498.08A8.5 8.5 0 1 1 3.5 12Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M11.143 7.557a.75.75 0 1 0-.287-1.473A6.015 6.015 0 0 0 12.014 18a6.015 6.015 0 0 0 5.902-4.856.75.75 0 1 0-1.473-.287 4.515 4.515 0 0 1-8.942-.87 4.515 4.515 0 0 1 3.643-4.43Z"
    })]
  }));
};

var Terminal = function Terminal(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 4.75C3 3.784 3.784 3 4.75 3h14.5c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 19.25 21H4.75A1.75 1.75 0 0 1 3 19.25V4.75Zm1.75-.25a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25h14.5a.25.25 0 0 0 .25-.25V4.75a.25.25 0 0 0-.25-.25H4.75Zm1.97 2.72a.75.75 0 0 1 1.06 0l1.75 1.75a.75.75 0 0 1 0 1.06l-1.75 1.75a.75.75 0 0 1-1.06-1.06L7.94 9.5 6.72 8.28a.75.75 0 0 1 0-1.06ZM10 11.25a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Z"
    })
  }));
};

var TestTube = function TestTube(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.72 3.22a.75.75 0 0 1 1.06 0l7 7a.75.75 0 1 1-1.06 1.06l-.47-.47-9.97 9.97a4.286 4.286 0 0 1-6.06-6.06l9.97-9.97-.47-.47a.75.75 0 0 1 0-1.06Zm1.53 2.59L8.061 12h7.879l2.25-2.25-3.94-3.94Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M21.004 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1-3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
    })]
  }));
};

var TextWidth = function TextWidth(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M10.64 11.4V4.62H8.168V3h6.828v1.62h-2.46v6.78H10.64Zm9.252 4.394-3.143-3.143a.857.857 0 1 0-1.212 1.212l1.68 1.68h-5.36a.857.857 0 0 0 0 1.714h5.36l-1.68 1.68a.857.857 0 1 0 1.212 1.212l3.143-3.143a.857.857 0 0 0 0-1.212Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "m3.25 15.794 3.144-3.143a.857.857 0 1 1 1.212 1.212l-1.68 1.68h5.36a.857.857 0 0 1 0 1.714h-5.36l1.68 1.68a.857.857 0 1 1-1.212 1.212l-3.143-3.143a.857.857 0 0 1 0-1.212Z"
    })]
  }));
};

var ThumbsDown = function ThumbsDown(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.586 4.5a2.249 2.249 0 0 0-2.223 1.911l-.837 5.5A2.25 2.25 0 0 0 5.75 14.5h5.24a.75.75 0 0 1 .741.866l-.575 3.691A1.25 1.25 0 0 0 12.39 20.5a.258.258 0 0 0 .228-.136l3.885-7.546V4.5H6.586Zm11.416 0v8h2.248a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25h-2.248Zm-.421 9.5h2.669A1.75 1.75 0 0 0 22 12.25v-7.5A1.75 1.75 0 0 0 20.25 3H6.586A3.749 3.749 0 0 0 2.88 6.186l-.837 5.5A3.75 3.75 0 0 0 5.75 16h4.364l-.44 2.826A2.75 2.75 0 0 0 12.389 22c.65 0 1.26-.362 1.561-.949L17.58 14Z"
    })
  }));
};

var ThumbsUp = function ThumbsUp(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.054 2.949A1.75 1.75 0 0 1 11.611 2a2.753 2.753 0 0 1 2.722 3.174L13.893 8h4.366a3.75 3.75 0 0 1 3.707 4.314l-.837 5.5A3.75 3.75 0 0 1 17.422 21H3.75A1.75 1.75 0 0 1 2 19.25v-7.5c0-.966.784-1.75 1.75-1.75h2.671l3.633-7.051ZM6 11.5H3.75a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25H6v-8Zm1.5 8h9.922a2.25 2.25 0 0 0 2.224-1.912l.837-5.5A2.25 2.25 0 0 0 18.26 9.5h-5.243a.75.75 0 0 1-.74-.866l.575-3.691A1.253 1.253 0 0 0 11.61 3.5a.252.252 0 0 0-.224.136L7.5 11.182V19.5Z"
    })
  }));
};

var Toggle = function Toggle(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("g", {
      clipPath: "url(#icon/toggle__a)",
      children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.5 11.75A5.75 5.75 0 0 1 7.25 6h10.5a5.75 5.75 0 0 1 5.75 5.75v.5A5.75 5.75 0 0 1 17.75 18H7.25a5.75 5.75 0 0 1-5.75-5.75v-.5Zm16-4.25a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Z"
      })
    }), /* @__PURE__ */jsxRuntimeExports.jsx("defs", {
      children: /* @__PURE__ */jsxRuntimeExports.jsx("clipPath", {
        id: "icon/toggle__a",
        children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
          d: "M0 0h24v24H0z"
        })
      })
    })]
  }));
};

var Toolbar = function Toolbar(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M3 4.75C3 3.784 3.784 3 4.75 3h14.5c.966 0 1.75.784 1.75 1.75v6a.75.75 0 0 1-1.5 0v-6a.25.25 0 0 0-.25-.25H4.75a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25h6a.75.75 0 0 1 0 1.5h-6A1.75 1.75 0 0 1 3 19.25V4.75Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      d: "M12.374 11.143a1 1 0 0 0-1.23 1.23l2.48 9.019c.233.844 1.361 1.003 1.818.256l2.355-3.852 3.852-2.355c.747-.457.588-1.585-.256-1.817l-9.02-2.48Z"
    })]
  }));
};

var Trends = function Trends(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.215 5.411a2 2 0 0 1 .374 2.804l-4.29 5.61a4 4 0 0 1-4.614 1.304l-2.59-.996-4.68 4.681a2 2 0 0 1-2.83-2.828l4.682-4.681a4 4 0 0 1 4.264-.905l2.59.996-.718 1.867.718-1.867 4.29-5.61a2 2 0 0 1 2.804-.375Z"
    })
  }));
};

var Upload = function Upload(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 5.5a5.253 5.253 0 0 0-4.965 3.537.75.75 0 0 1-.613.5A4.501 4.501 0 0 0 7 18.5h2A.75.75 0 0 1 9 20H7A6 6 0 0 1 5.78 8.124a6.751 6.751 0 0 1 12.954 2.164A4.876 4.876 0 0 1 18.125 20H15a.75.75 0 0 1 0-1.5h3.125a3.375 3.375 0 1 0-.107-6.748.75.75 0 0 1-.773-.781A5.25 5.25 0 0 0 12 5.5Zm-3.03 8.22 2.5-2.5a.75.75 0 0 1 1.06 0l2.5 2.5a.75.75 0 1 1-1.06 1.06l-1.22-1.22v5.69a.75.75 0 0 1-1.5 0v-5.69l-1.22 1.22a.75.75 0 1 1-1.06-1.06Z"
    })
  }));
};

var User = function User(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 3.5a8.5 8.5 0 0 0-6.223 14.29C7.247 16.074 9.417 15 12 15c2.583 0 4.752 1.074 6.223 2.79A8.5 8.5 0 0 0 12 3.5Zm5.108 15.294C15.917 17.388 14.151 16.5 12 16.5c-2.15 0-3.917.888-5.109 2.294A8.46 8.46 0 0 0 12 20.5a8.46 8.46 0 0 0 5.108-1.706ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10c0 2.974-1.3 5.646-3.359 7.476A9.965 9.965 0 0 1 12 22a9.965 9.965 0 0 1-6.641-2.524A9.977 9.977 0 0 1 2 12Zm10-4.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM8 10a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z"
    })
  }));
};

var UserPaths = function UserPaths(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 9.5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v5.5ZM3 18a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12Zm16 3.5a1 1 0 0 1-1-1V15a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v5.5a1 1 0 0 1-1 1h-1ZM17.5 8a1 1 0 0 1-1 1h-1.992a1 1 0 0 0-.563.174l-3.89 2.652a1 1 0 0 1-.563.174 1 1 0 0 1 .563.174l3.89 2.652a1 1 0 0 0 .563.174H16.5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1.992a1 1 0 0 1-.563-.174l-3.89-2.652A1 1 0 0 0 9.492 17H7.5a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1.992a1 1 0 0 0 .563-.174l3.89-2.652A1 1 0 0 1 14.508 4H16.5a1 1 0 0 1 1 1v3Z"
    })
  }));
};

var Warning = function Warning(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.49 2.844a1.75 1.75 0 0 1 3.02 0l8.506 14.521c.683 1.167-.158 2.635-1.51 2.635H3.495c-1.352 0-2.194-1.468-1.51-2.635l8.505-14.52ZM12 9a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 12 9Zm1 6.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    })
  }));
};

var Webhooks = function Webhooks(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsxs("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.147 17.606H7.324v1.16a2.543 2.543 0 0 1-2.507 2.09 2.539 2.539 0 0 1-2.545-2.533c0-.864.434-1.626 1.097-2.083l-.73-1.038A3.792 3.792 0 0 0 1 18.322c0 2.099 1.71 3.8 3.817 3.8 1.89 0 3.46-1.368 3.765-3.164h9.514c.22.377.63.63 1.1.63a1.27 1.27 0 0 0 1.272-1.266 1.273 1.273 0 0 0-2.322-.717Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.678 17.796A1.267 1.267 0 0 1 4.85 17l4.772-8.265a3.803 3.803 0 0 1-.867-4.833 3.802 3.802 0 0 1 7.08 1.571l-1.262.11a2.535 2.535 0 1 0-3.868 2.372l.697.403-5.404 9.361c.154.321.17.701.023 1.045a1.268 1.268 0 1 1-2.342-.969Z"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m11.935 7.06 5.351 9.266.637-.368.01.02.017-.01c1.213-.7 2.758-.295 3.45.906.694 1.201.273 2.742-.94 3.442a2.538 2.538 0 0 1-2.345.107l-.54 1.143a3.811 3.811 0 0 0 3.513-.163c1.82-1.05 2.451-3.362 1.411-5.163-.94-1.626-2.92-2.28-4.635-1.62l-4.748-8.222a1.252 1.252 0 0 0-.01-1.23 1.262 1.262 0 0 0-1.726-.454 1.262 1.262 0 0 0-.47 1.721c.22.382.613.603 1.025.624Z"
    })]
  }));
};

var X = function X(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread(_objectSpread({
    width: "100%",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.75 3.69 12 10.94l7.25-7.25 1.06 1.06L13.06 12l7.25 7.25-1.06 1.06L12 13.06l-7.25 7.25-1.06-1.06L10.94 12 3.69 4.75l1.06-1.06Z"
    })
  }));
};

export { Advanced, App, Apps, ArrowLeft, ArrowRight, ArrowUpRight, Badge, Bell, Bolt, Book, Box, Brackets, Brightness, Calculator, Calendar, Chat, Check, CheckCircle, ChevronDown, Clock, Code, Columns, Cursor, Dashboard, Database, Download, Ellipsis, External, Features, Filter, Flag, Flask, Funnels, Gear, GraduationCap, Graph, GridMasonry, HardDrive, HogQL, Home, Info, Laptop, Lifecycle, LightBulb, Logomark, Magic, Map$1 as Map, Message, Multiply, Newspaper, People, Percentage, Person, Privacy, Profile, Pulse, Question, Quote, Receipt, Retention, Rewind, RewindPlay, Ribbon, Rocket, Sampling, Search, Send, Server, Share, Shield, Stack, Stickiness, Store, Target, Terminal, TestTube, TextWidth, ThumbsDown, ThumbsUp, Toggle, Toolbar, Trends, Upload, User, UserPaths, Warning, Webhooks, X };